import { Reducer } from 'redux';
import { AnnouncementActionTypes, AnnouncementState } from 'types';

const initialState: AnnouncementState = {};

const reducer: Reducer<AnnouncementState> = (
  state = initialState,
  action: any
) => {
  switch (action.type) {
    case AnnouncementActionTypes.GET_LIST_ANNOUNCEMENTS_START: {
      return {
        ...state,
        processing: 'loading',
        listAnnouncements: action.payload
      };
    }
    case AnnouncementActionTypes.GET_LIST_ANNOUNCEMENTS_SUCCESS: {
      return {
        ...state,
        processing: undefined,
        listAnnouncements: action.payload
      };
    }
    case AnnouncementActionTypes.GET_LIST_ANNOUNCEMENTS_FAILURE: {
      return {
        ...state,
        processing: undefined,
        error: action.payload
      };
    }
    default: {
      return state;
    }
  }
};

export { reducer as AnnouncementReducer };
